import { isInShell } from '../nativeBridge/shellPresence';
import { platformContextService } from '../platformContext/PlatformContextService';
import { PlatformEnum } from '../platformContext/platformContextTypes';

import type { LifecycleEventData, NoDataEventNames, DataEventNames } from './lifecycleEventEmitterTypes';

class LifecycleEventEmitterService {
  private get platform() {
    return platformContextService.getConfig().platform;
  }

  public emitMessage<T extends NoDataEventNames>(type: T): void;
  public emitMessage<T extends DataEventNames>(type: T, payload: LifecycleEventData[T]): void;
  public emitMessage<T extends keyof LifecycleEventData>(type: T, payload?: LifecycleEventData[T]): void {
    // These bare `ON_APP_*` messages are the native app's protocol. The mobile shell speaks the bridge's
    // envelopes only and drops each of these as malformed; its `ui.ready` is sent by `postUiReady`.
    if (isInShell()) {
      return;
    }
    const reactNativeWebView = window.webkit?.messageHandlers?.ReactNativeWebView || window.ReactNativeWebView;
    if (reactNativeWebView && this.platform !== PlatformEnum.WEB) {
      reactNativeWebView.postMessage(JSON.stringify({ type, payload }));
    } else {
      window.parent.postMessage({ type, payload }, '*');
    }
  }
}

export const lifecycleEventEmitterService = new LifecycleEventEmitterService();
